import React from "react";
import "./styles.css";
import { IoMdClose, IoMdDownload } from "react-icons/io";
import { Link, useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import Certificado from "../../PageTrilhaDeConhecimento/certificado";
import api from "../../../services/api";
import PDFCertificadoWrapper, {
  DownloadCertificadoButton,
} from "../../../pages/PageTrilhaNew/Certificado";
import { useTheme, useMediaQuery } from "@mui/material";
import {
  Box,
  Typography,
  Chip,
  LinearProgress,
  Button,
  IconButton,
} from "@mui/material";

export default function MeusCursos() {
  const [trilhas, setTrilhas] = useState([]);
  const [busca, setBusca] = useState("");
  const [filtroIniciadas, setFiltroIniciadas] = useState(false);
  const signed = useSelector((state) => state.auth.signed);
  const [loading, setLoading] = useState(false);

  const [cursos, setCursos] = useState([]);
  const [atualiza, setAtualiza] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  let profile = useSelector((state) =>
    state.user.profile.dataValues
      ? state.user.profile.dataValues
      : state.user.profile
  );
  // const cursos = [
  //   {
  //     id: 1,
  //     nome: "Cybersegurança",
  //     progresso: 25,
  //     status: "em aberto",
  //     acao: "Continuar",
  //   },
  //   {
  //     id: 2,
  //     nome: "Introdução HTML e CSS",
  //     progresso: 100,
  //     status: "concluído",
  //     acao: "Finalizado",
  //   },
  //   {
  //     id: 3,
  //     nome: "Flutter",
  //     progresso: 25,
  //     status: "em aberto",
  //     acao: "Continuar",
  //   },
  //   {
  //     id: 4,
  //     nome: "Desenvolvimento com React",
  //     progresso: 100,
  //     status: "concluído",
  //     acao: "Finalizado",
  //   },
  // ];

  useEffect(() => {
    const fetchTrilhas = async () => {
      if (signed && !filtroIniciadas) {
        try {
          setLoading(true);
          const response = await api.get("/trilhas-de-conhecimento/aluno");
          setTrilhas(response.data);
          setLoading(false);
        } catch (error) {
          console.error("Erro ao buscar trilhas de conhecimento:", error);
        }
      } else if (signed && filtroIniciadas) {
        try {
          setLoading(true);
          const response = await api.get(
            "/trilhas-de-conhecimento/inscricao/trilhas-by-aluno"
          );
          setTrilhas(response.data);
          setLoading(false);
        } catch (error) {
          console.error("Erro ao buscar trilhas de conhecimento:", error);
        }
      } else {
        try {
          setLoading(true);
          const response = await api.get("/trilhas-de-conhecimento/");
          setTrilhas(response.data);
          setLoading(false);
        } catch (error) {
          console.error("Erro ao buscar trilhas de conhecimento:", error);
        }
      }
    };

    fetchTrilhas();
  }, [filtroIniciadas]);

  const getBadgeClass = (status) => {
    switch (status) {
      case "em andamento":
        return "badge badge-open";
      case "concluido":
        return "badge badge-completed";
      case "esgotado":
        return "badge badge-expired";
      default:
        return "badge";
    }
  };

  const getButtonClass = (acao) => {
    if (acao === "Finalizado") {
      return "action-button button-completed";
    }
    return "action-button button-continue";
  };

  const getActionIcon = (status) => {
    if (status === "concluido") {
      return <IoMdDownload size={25} color="black" />;
    }
    return <IoMdClose size={25} color="black" />;
  };

  return (
    <div className="cursos-container">
      <div className="cursos-header">
        <h2 className="cursos-title">Cursos</h2>
        <Link to="/oxetrilhas" className="ver-todos-button">
          Ver todos
        </Link>
      </div>

      {isMobile ? (
        <div className="mobile-cards-wrapper">
          {trilhas.map((curso) => {
            if (!curso.inscrito) return null;

            const progresso = curso.performance.progresso == 1 ? 100 : 0;
            const status = curso.concluido ? "concluido" : "em andamento";

            return (
              <Box
                key={curso.id}
                className="mobile-card"
                sx={{
                  backgroundColor: "#fff",
                  borderRadius: "12px",
                  padding: 2,
                  marginBottom: 2,
                  boxShadow: "0px 2px 8px rgba(0,0,0,0.05)",
                }}
              >
                <Box display="flex" alignItems="center" gap={1}>
                  <Box className="curso-icon">
                    <svg viewBox="0 0 24 24" width="20" height="20">
                      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                      <polyline points="14 2 14 8 20 8"></polyline>
                      <line x1="16" y1="13" x2="8" y2="13"></line>
                      <line x1="16" y1="17" x2="8" y2="17"></line>
                      <polyline points="10 9 9 9 8 9"></polyline>
                    </svg>
                  </Box>
                  <Typography fontWeight={600} fontSize={16}>
                    {curso.titulo}
                  </Typography>
                </Box>

                <Box mt={2}>
                  <LinearProgress
                    variant="determinate"
                    value={progresso}
                    sx={{ height: 8, borderRadius: 5 }}
                  />
                  <Typography fontSize={12} color="#9ca3af" mt={0.5}>
                    {progresso}% do curso concluído
                  </Typography>
                </Box>

                <Chip
                  label={status === "concluido" ? "Concluído" : "Em andamento"}
                  className={getBadgeClass(status)}
                  sx={{ marginTop: 1 }}
                />

                <Box
                  mt={2}
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Button
                    variant="contained"
                    size="medium"
                    className={getButtonClass(
                      status === "concluido" ? "Finalizado" : ""
                    )}
                    component={Link}
                    to={
                      curso.concluido ? "/oxetrilhas" : `/oxetrilha/${curso.id}`
                    }
                    sx={{
                      backgroundColor: "#f56a25",
                    }}
                  >
                    {curso.concluido ? "Finalizado" : "Continuar"}
                  </Button>

                  {curso.concluido ? (
                    <PDFCertificadoWrapper
                      nome={profile.name}
                      curso={curso.titulo}
                      cargaHoraria={curso.carga_horaria}
                    >
                      <IconButton>
                        <IoMdDownload />
                      </IconButton>
                    </PDFCertificadoWrapper>
                  ) : (
                    <IconButton disabled>
                      <IoMdClose />
                    </IconButton>
                  )}
                </Box>
              </Box>
            );
          })}
        </div>
      ) : (
        <div className="table-container">
          <table className="cursos-table">
            <thead>
              <tr>
                <th></th>
                <th>Progresso</th>
                <th>Status</th>
                <th>Acessar</th>
                <th>Certificado</th>
              </tr>
            </thead>
            <tbody>
              {trilhas.map((curso) => {
                if (!curso.inscrito) return null;

                return (
                  <tr key={curso.id}>
                    <td>
                      <div className="curso-info">
                        <div className="curso-icon">
                          <svg viewBox="0 0 24 24" width="20" height="20">
                            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                            <polyline points="14 2 14 8 20 8"></polyline>
                            <line x1="16" y1="13" x2="8" y2="13"></line>
                            <line x1="16" y1="17" x2="8" y2="17"></line>
                            <polyline points="10 9 9 9 8 9"></polyline>
                          </svg>
                        </div>
                        <span className="curso-nome">{curso.titulo}</span>
                      </div>
                    </td>
                    <td>
                      <div className="progresso-container">
                        <div className="progresso-bar">
                          <div
                            className="progresso-fill"
                            style={{
                              width: `${
                                curso.performance.progresso == 1 ? "100" : "0"
                              }%`,
                            }}
                          ></div>
                        </div>
                        <div className="progresso-text">
                          {curso.performance.progresso == 1 ? "100" : "0"}% do
                          curso concluído
                        </div>
                      </div>
                    </td>
                    <td>
                      <span
                        className={getBadgeClass(
                          curso.concluido ? "concluido" : "em andamento"
                        )}
                      >
                        {curso.concluido ? "Concluido" : "Em andamento"}
                      </span>
                    </td>
                    <td>
                      <Link
                        to={
                          curso.concluido
                            ? "/oxetrilhas"
                            : `/oxetrilha/${curso.id}`
                        }
                        className={getButtonClass(
                          curso.concluido ? "Finalizado" : ""
                        )}
                      >
                        {curso.concluido ? "Finalizado" : "Continuar"}
                      </Link>
                    </td>
                    <td>
                      {/* <div className="icon-container">
                      {getActionIcon(curso.concluido && "concluido")}
                    </div> */}
                      {curso.concluido ? (
                        <PDFCertificadoWrapper
                          nome={profile.name}
                          curso={curso.titulo}
                          cargaHoraria={curso.carga_horaria}
                        >
                          <div
                            className="icon-container"
                            title="Baixar certificado"
                            onClick={(e) => e.stopPropagation()}
                          >
                            {getActionIcon("concluido")}
                          </div>
                        </PDFCertificadoWrapper>
                      ) : (
                        <div
                          className="icon-container"
                          title="Certificado indisponível"
                        >
                          {getActionIcon("em andamento")}
                        </div>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
